import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Container } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import InternalLink from '../../links/Internal/InternalLink';
import TopBarItem from '../top-bar-items/TopBarItem';
import style from './TopBar.style';
import HeadingVerySmall from '../../../core/typography/headings/very-small/HeadingVerySmall';
import stylesConfig from '../../../theme/config';
import pimaLogo from '../../../../assets/pimaLogo.svg'

function TopBar() {
  const navBarMenuItems = [
    // schema for adding a navBarItem.
    {
      title: 'Account',
      cy: 'account',
      icon: AccountCircleOutlinedIcon,
      topLevelOnClick: () => {},
      active: [],
      subMenuItems: {
        logout: {
          title: 'Logout',
          // onClick: () => logout(),
          cy: 'logout',
        },
      },
    },
  ];

  return (
    <AppBar style={style.navBar} elevation={0} position="absolute">
      <Container sx={{ minWidth: '100%' }}>
        <Toolbar style={style.toolBar}>
          <Box style={style.logoBox}>
            <InternalLink to="/">
              <img style={style.logo} alt="Logo" src={pimaLogo}/>
            </InternalLink>
            <HeadingVerySmall text={'Profiler to Inventory Mapping Assistant (PIMA)'} 
                sx={{
                  color: stylesConfig.colors.black,
                  marginBottom: '.5rem',
                  fontWeight: 800,
                }}/>
          </Box>
          <Box style={style.searchBox}>
            {/* this is where search bar will go */}
            {/* { isGlobalSearching && <UniversalSerarch />} */}
          </Box>
          {/* <Box style={style.pagesBox}>
            {navBarMenuItems.map((item) => {
              return (
                <TopBarItem
                  subMenuItems={item.subMenuItems}
                  title={item.title}
                  cy={item.cy}
                  icon={item.icon}
                  key={item.title}
                  onClick={item.topLevelOnClick}
                  active={item.active}
                />
              );
            })}
          </Box> */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default TopBar;
